import { gql } from '@apollo/client'

export const CREATE_AFFILIATE_SINGLE_SIGN_ON_LINK = gql`
  query ($accountId: Int!) {
    data: createAffiliateSingleSignOnLink(accountId: $accountId) {
      link
    }
  }
`
